import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Drawer, Grid, Typography } from '@mui/material';
import {
  convertToEpoch2,
} from '../../../../../../utils/commonFunctions';
import {  useAppSelector } from '../../../../../../app/redux/hooks';
import { useDynamicYupSchema } from '../../../../../hooks/useDynamicSchema';
import { useUpdateYaantracHooks } from './hooks/UpdateYaantracHooks';
import CustomTextField from '../../../../../components/customized/customtextfield/CustomTextField';
import CustomButton from '../../../../../components/buttons/CustomButton';
import CustomDateCalendar from '../../../../../components/customized/customcalendar/CustomCalendar';
import LoginRedirect from '../../../../../components/loginredirect/LoginRedirect';
import { UpdateYaantracData } from './componentDatas/UpdateYaantracData';

interface UpdateYaantrac {
  open: boolean;
  setOpen: any;
  roleType: string;
  filteredRow: any;
}

const UpdateYaantrac = ({ open, setOpen, roleType, filteredRow }: UpdateYaantrac) => {
  const { isLoading } = useAppSelector(state => state.updateYaantrac);

  const { createFormFields } = useDynamicYupSchema(null);
  const { schema } = createFormFields(UpdateYaantracData());

  const {
    control,
    handleSubmit,
    setValue,
    reset,
    trigger,
  } = useForm({
    resolver: yupResolver(schema)
  });

  const { onSubmit, handleClose } = useUpdateYaantracHooks({
    setOpen,
    reset,
    setValue,
    filteredRow
  });

  return (
    <>
      <Box p={2}>
        <Drawer
          anchor='right'
          open={open}
          sx={{ zIndex: 1400 }}
          onClose={() => {
            setOpen(false);
            reset();
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '15px !important'
            }}
          >
            <Typography
              sx={{ fontWeight: 700 }}
            >{`${roleType} Vehicle Details`}</Typography>
            <Box
              sx={{ display: 'flex', flexDirection: 'column', gap: 15 }}
              className='yaantrac-container'
            >
              <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={1}>
                  {UpdateYaantracData()?.map(item => (
                    <Grid item key={item.id} xs={12} className='yaantrac-item'>
                      {item?.id === '1' || item.id === '2' || item.id === '3' ? (
                        <CustomDateCalendar
                          id={item.id}
                          name={item.name}
                          control={control}
                          disableFuture={
                            item?.name === 'lastServiceDate' ||
                            item?.name === 'dotInspectionDate'
                              ? true
                              : false
                          }
                          disablePast={['insuranceExpiryDate'].includes(item.name)}
                          placeholder={item.placeholder}
                          label={item.label}
                          value={
                            filteredRow
                              ? dayjs.unix(
                                  item.name === 'dotInspectionDate' &&
                                    filteredRow?.row?.dotInspectionDate !== null
                                    ? filteredRow?.row?.dotInspectionDate / 1000
                                    : item.name === 'insuranceExpiryDate' &&
                                      filteredRow?.row?.insuranceExpiryDate !== null
                                    ? filteredRow?.row?.insuranceExpiryDate / 1000
                                    : item.name === 'lastServiceDate' &&
                                      filteredRow?.row?.lastServicedDate !== null
                                    ? filteredRow?.row?.lastServicedDate / 1000
                                    : filteredRow?.row?.lastServicedDate / 1000
                                )
                              : null
                          }
                          onDateChange={(date: any) => {
                            if (date?.$d && date?.$d != 'Invalid Date') {
                              const epoc = convertToEpoch2(date?.$d);
                              setValue(item.name, epoc !== null ? String(epoc) : '');
                              trigger(item?.name);
                            } else {
                              setValue(item?.name, '');
                              trigger(item?.name);
                            }
                          }}
                        />
                      ) : item.id === '4' ? (
                        <Grid>
                          <Typography
                            sx={{
                              fontFamily: "'Inter', sans-serif !important",
                              fontSize: '14px !important',
                              fontWeight: '700 !important',
                              color: '#26134b',
                              marginTop: '10px'
                            }}
                          >
                            {item.label}
                          </Typography>
                        </Grid>
                      ) : (
                        <CustomTextField
                          key={item.id}
                          control={control}
                          name={item.name}
                          placeholder={item.placeholder}
                          id={item.id}
                          label={item.label}
                          type={item.type === 'string' ? 'text' : 'number'}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
                <Box sx={{ marginTop: '5%', display: 'flex', gap: '15px' }}>
                  <CustomButton
                    className='saveChanges'
                    type='submit'
                    category={roleType}
                    loading={isLoading}
                  />
                  <CustomButton
                    className='cancel'
                    category='Cancel'
                    onClick={() => {
                      handleClose();
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Drawer>
      </Box>
      <LoginRedirect />
    </>
  );
};

export default UpdateYaantrac;
